var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPolichat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 42",
    style: {
      enableBackground: "new 0 0 150 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.367,
    y1: 12.113,
    x2: 45.9184,
    y2: 35.3752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,28.5h-2.9c-2.9,0-5.7-1.3-7.5-3.6c-1.8-2.3-2.5-5.2-1.9-8.1c0,0,0-0.1,0-0.1l0.1-0.2 c0.1-0.3,0.1-0.6,0.2-0.9c-0.7,0-1.2,0-1.4,0c-0.5,0-1.1,0-1.7,0.2c-2.3,0.6-2.7,2.7-2.9,3.4c-0.3,1.6-0.7,3.2-1.1,4.8l-0.1,0.5 c-0.2,1-0.5,2-0.7,3c-0.2,0.9-0.4,1.7-0.6,2.6c-0.1,0.5-0.2,1-0.3,1.5c-0.2,0.7-0.3,1.4-0.5,2.2c-0.3,1.3,0.1,2.4,1.1,3.1 c0.5,0.3,1,0.4,1.5,0.4c0.6,0,1.3-0.2,1.8-0.7c0.6-0.5,1.2-0.9,1.8-1.4c1-0.8,2-1.5,3-2.4c0.3-0.2,0.5-0.3,0.9-0.3 c2.3,0,4.6,0,6.9,0l1,0c1.9,0,3.2-1,3.7-2.7c0.1-0.2,0.2-0.6,0.3-1.2l-0.4,0C56.9,28.5,56.8,28.5,56.7,28.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8859,
    y1: 13.0097,
    x2: 54.4373,
    y2: 36.272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,6.3c-0.5-0.3-1-0.4-1.5-0.4c-0.6,0-1.3,0.2-1.8,0.7C63,7,62.4,7.5,61.7,7.9c-1,0.8-2,1.5-3,2.4 c-0.3,0.2-0.5,0.3-0.9,0.3c-2.3,0-4.6,0-6.9,0l-1,0c-1.9,0-3.2,1-3.7,2.7c-0.1,0.2-0.2,0.6-0.3,1.2l0.4,0c0.1,0,0.2,0,0.3,0h2.9 c2.9,0,5.7,1.3,7.5,3.6v0c1.8,2.3,2.5,5.2,1.9,8.1c0,0,0,0.1,0,0.1l-0.1,0.2c-0.1,0.3-0.1,0.6-0.2,0.9c0.7,0,1.2,0,1.4,0 c0.5,0,1.1,0,1.7-0.2c2.3-0.6,2.7-2.7,2.9-3.4c0.3-1.6,0.7-3.2,1.1-4.8l0.1-0.5c0.2-1,0.5-2,0.7-3c0.2-0.9,0.4-1.7,0.6-2.6 c0.1-0.5,0.2-1,0.3-1.5c0.2-0.7,0.3-1.4,0.5-2.2C68.3,8.1,67.9,6.9,66.9,6.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.6033,
    y1: 12.5589,
    x2: 50.1547,
    y2: 35.8212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,15.5l-3.3,0c-0.1,0-0.2,0-0.3,0.1c-0.2,0.1-0.2,0.1-0.5,1.3l-0.1,0.2c0,0,0,0.1,0,0.1 c-0.6,2.6,0.1,5.2,1.8,7.2c1.6,1.8,3.9,2.9,6.5,2.9h2.4c0.1,0,0.1,0,0.2,0l0.6,0c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.3 l0.3-1.2c0,0,0-0.1,0-0.1c0.6-2.6-0.1-5.2-1.8-7.2C54.5,16.6,52.1,15.5,49.6,15.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.0286,
    y1: 15.6563,
    x2: 79.58,
    y2: 38.9186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.9,14.4c-1.6,0-3,0.5-4.2,1.5l-1.5-1c-0.1,0-0.1-0.1-0.2-0.1h-1.2c-0.2,0-0.4,0.2-0.4,0.4v17.8 c0,0.1,0.1,0.2,0.2,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l3.5-1.5c0.1-0.1,0.2-0.2,0.2-0.4v-3.2c1,0.5,2.1,0.8,3.2,0.8 c2.1,0,3.8-0.7,5.2-2.1c1.4-1.4,2.1-3.1,2.1-5.2c0-2.1-0.7-3.8-2.1-5.2C85.7,15.1,83.9,14.4,81.9,14.4z M83.9,24 c-0.6,0.6-1.4,0.9-2.3,0.9c-0.9,0-1.7-0.3-2.3-0.9c-0.6-0.6-0.9-1.4-0.9-2.3c0-0.6,0.1-1.2,0.4-1.7c0.3-0.5,0.6-0.9,1.1-1.1 c0.5-0.3,1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.6,0.4c0.5,0.3,0.9,0.6,1.1,1.1c0.3,0.5,0.4,1,0.4,1.7C84.8,22.6,84.5,23.3,83.9,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9382,
    y1: 17.331,
    x2: 95.4896,
    y2: 40.5933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.5,14.4c-2.1,0-3.9,0.7-5.3,2.1c-1.4,1.4-2.1,3.1-2.1,5.2c0,1.4,0.3,2.6,1,3.7c0.6,1.1,1.5,2,2.7,2.6 c1.1,0.6,2.4,0.9,3.8,0.9c2.1,0,3.9-0.7,5.3-2.1c1.4-1.4,2.1-3.1,2.1-5.2c0-2.1-0.7-3.8-2.1-5.2C101.4,15.1,99.6,14.4,97.5,14.4z  M99.7,24c-0.6,0.6-1.3,0.9-2.2,0.9c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-1-0.6c-0.3-0.3-0.5-0.6-0.6-1 c-0.2-0.4-0.2-0.9-0.2-1.3c0-1,0.3-1.7,0.9-2.3c0.6-0.6,1.3-0.9,2.2-0.9c0.9,0,1.7,0.3,2.2,0.9c0.6,0.6,0.9,1.4,0.9,2.3 C100.6,22.6,100.3,23.4,99.7,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.8722,
    y1: 18.4819,
    x2: 106.4235,
    y2: 41.7442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.8,11.3l-3.5-1.3c-0.1,0-0.2,0-0.4,0c-0.1,0.1-0.2,0.2-0.2,0.3v17.8c0,0.1,0.1,0.3,0.2,0.3 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l3.5-1.7c0.1-0.1,0.2-0.2,0.2-0.3V11.7C111,11.5,110.9,11.4,110.8,11.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.0939,
    y1: 19.1369,
    x2: 112.6453,
    y2: 42.3991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M117.8,9.7c-0.1-0.1-0.2-0.1-0.3-0.1l-3.5,1.1c-0.2,0-0.3,0.2-0.3,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3.5 c0.2,0,0.4-0.2,0.4-0.4v-3.3C118,9.9,117.9,9.8,117.8,9.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0738,
    y1: 19.24,
    x2: 113.6251,
    y2: 42.5023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.6,14.7H114c-0.2,0-0.4,0.2-0.4,0.4V27c0,0.2,0.1,0.3,0.3,0.4l3.5,1.2c0,0,0.1,0,0.1,0 c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3V15.1C118,14.9,117.8,14.7,117.6,14.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPolichat);
export default __webpack_public_path__ + "static/media/logo-polichat.337ad828deecb3d9f2f11ffae0ce49d7.svg";
export { ForwardRef as ReactComponent };